import BaseApi from './base'
import config from '../../config.json'

export default class BooksApi extends BaseApi {
  constructor() {
    super()
  }

  getAll() {
    return this.axios.get(`${config.apiUrl}/books`).then(({ data }) => data)
  }

  getBook(id) {
    return this.axios
      .get(`${config.apiUrl}/books/${id}`)
      .then(({ data }) => data.book)
  }

  getChapter(id) {
    return this.axios
      .get(`${config.apiUrl}/chapters/${id}`)
      .then(({ data }) => data)
  }

  getChapterStatus(id) {
    return this.axios
      .get(`${config.apiUrl}/chapters/${id}/user-status`)
      .then(({ data }) => data)
  }
}
